import { useMutation } from "@tanstack/react-query";
import type { PaymentLinkCreatePaymentIntentResponseType } from "@sellar-io/api-v2/types";
import { apiV2Request, apiV2AssertResponse } from "../apiV2Request";

export const usePaymentLinkPaymentIntentCreate = (code: string) => {
  return useMutation({
    mutationFn: (data: { stripePaymentMethodId?: string }) =>
      apiV2Request({
        method: "post",
        path: `payment-link/ref/${code}/payment-intent`,
        business: null,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse<PaymentLinkCreatePaymentIntentResponseType>(data)
            .data,
      ),
  });
};
